class MultiProductButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button.multi-product-add-button');
    this.spinner = this.querySelector('.loading-overlay__spinner');
    this.productMaxCounts = {};

    // Parse the product max counts data if available
    if (this.dataset.productMaxCounts) {
      try {
        this.productMaxCounts = JSON.parse(this.dataset.productMaxCounts);
      } catch (e) {
        console.error('Error parsing product max counts:', e);
      }
    }

    if (this.button) {
      this.button.addEventListener('click', this.addProductsToCart.bind(this));
    }
  }

  async addProductsToCart(event) {
    event.preventDefault();

    // Show loading spinner
    this.button.classList.add('loading');
    this.spinner.classList.remove('hidden');

    try {
      // Get products from data attribute
      const productsData = this.button.dataset.products;
      if (!productsData) {
        console.error('No products selected');
        return;
      }

      const products = JSON.parse(productsData);
      if (!products.length) {
        console.error('No products selected');
        return;
      }

      // Get global max count from button data attribute
      const globalMaxCount = parseInt(this.button.dataset.maxCount) || 0;

      // Fetch current cart
      const cartResponse = await fetch('/cart.js');
      if (!cartResponse.ok) throw new Error('Failed to fetch cart');
      const cart = await cartResponse.json();

      // Track if we added any products
      let addedAnyProducts = false;

      // Add each product to cart sequentially
      for (const productHandle of products) {
        // Fetch product data to get the first available variant
        const productResponse = await fetch(`/products/${productHandle.handle}.js`);
        const productData = await productResponse.json();

        if (!productData.available) {
          console.warn(`Product ${productData.title} is not available`);
          continue;
        }

        // Find first available variant
        const variant = productData.variants.find(v => v.available) || productData.variants[0];

        // Check if this variant is already in the cart
        const cartItem = cart.items.find(item => item.variant_id === variant.id);

        // Get max count from the productMaxCounts object, fallback to global max count
        const maxCount = this.productMaxCounts[productHandle.handle] || globalMaxCount;

        // Skip if already at or above max quantity
        if (maxCount > 0 && cartItem && cartItem.quantity >= maxCount) {
          console.warn(`Maximum quantity (${maxCount}) reached for ${productData.title}, skipping`);
          continue;
        }

        // Add to cart
        const formData = {
          items: [{
            id: variant.id,
            quantity: 1
          }]
        };

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        });

        if (!response.ok) {
          throw new Error(`Failed to add ${productData.title} to cart`);
        }

        addedAnyProducts = true;
      }

      // Only refresh cart if we actually added something
      if (addedAnyProducts) {
        // Refresh cart drawer or redirect to cart page
        if (typeof window.refreshCart === 'function') {
          window.refreshCart();
        } else {
          window.location.href = '/cart';
        }
      } else {
        // If nothing was added, show a message
        alert('All products in this bundle are already in your cart or have reached maximum allowed quantity.');
      }

    } catch (error) {
      console.error('Error adding products to cart:', error);
      alert('There was an error adding products to your cart. Please try again.');
    } finally {
      // Hide loading spinner
      this.button.classList.remove('loading');
      this.spinner.classList.add('hidden');
    }
  }
}

customElements.define('multi-product-button', MultiProductButton);